import React, { useEffect } from "react";
import "./serviceDetails.css";
import Header from "./Header";
import { useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import Footer from "./Footer";

export default function ServiceDetails() {
  const location = useLocation();
  const { cardData } = location.state || {};
  const handleWhatsApp = () => {
    const phoneNumber = "91 8128188371";
    const message = encodeURIComponent(
      `Hello, I am interested in your ${cardData?.title} service.`
    );

    window.open(
      `https://wa.me/${phoneNumber}?text=${message}`,
      "_blank"
    );
  };

  // ✅ SCROLL TO TOP ON PAGE LOAD
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div className="service-details-page">
      <Header />

      {/* Animated Blob Background */}
      <div className="blob"></div>
      <div className="blobTwo"></div>

      <motion.div
        className="service-container"
        initial={{ opacity: 0, y: 70 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
      >
        {/* Left text section */}
        <motion.div
          className="service-left"
          initial={{ x: -40, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="service-title">{cardData?.title}</h1>
          <h3 className="service-subtitle">{cardData?.subtitle}</h3>

          <p className="service-description">{cardData?.description}</p>

          <motion.button
            className="explore-btn"
            whileHover={{ scale: 1.06 }}
            whileTap={{ scale: 0.93 }}
            onClick={handleWhatsApp}
          >
            Get This Service →
          </motion.button>
        </motion.div>

        {/* Right Image Section */}
        <motion.div
          className="service-right"
          initial={{ x: 40, opacity: 0 }}
          animate={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          <img
            src={cardData?.image}
            className="service-img"
            alt={cardData?.title}
          />
        </motion.div>
      </motion.div>

      <Footer />
    </div>
  );
}
